module.exports = __webpack_public_path__ + "static/img/行驶.ba45c50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/随车吊/行驶.png
// module id = yoNG
// module chunks = 76